import Validator from '../validator';

const ConfirmPasswordValidator = new Validator([
  {
    field: 'password',
    method: 'isEmpty',
    validWhen: false,
    message: 'Password is required.',
  },
  {
    field: 'passwordConfirm',
    method: 'isEmpty',
    validWhen: false,
    message: 'Password confirm is required.',
  },
]);

export default ConfirmPasswordValidator;
